// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__pvmKR","colCheckbox":"styles_colCheckbox__2msWt"};